import { Link } from '@maas-components/core'
import styled from 'styled-components'

export const StyledLink = styled(Link)`
  cursor: pointer;
  display: flex;
`
